export default __webpack_public_path__ + "static/media/w_wdt_c_0.f40c9692.mp3";